export const FX = '/images/adminUi/fx.svg';
export const BTC = '/common/crytoicons/btc.png';
export const ETH = '/common/crytoicons/eth1.png';
export const LTC = '/common/ltc.svg';
export const USDT = '/cryptonpay/usdt.png';
export const USDC = '/common/crytoicons/usd.png';
export const TRX = '/common/trx.svg';
export const DAI = '/common/crytoicons/dai.png';
export const Delete = '/adminUi/delete.svg';
export const DeleteIcon = '/adminUi/delete-icon.svg';
export const TrandUp = '/common/trandUp.svg';
export const TrandDown = '/common/trandDown.svg';
export const DepositIcon = '/adminUi/deposit.svg';
export const WithdrawalIcon = '/adminUi/withdrawal.svg';
export const TTPIcon = '/adminUi/tpp.svg';
export const FXIcon = '/adminUi/fx.svg';
export const MerchantIcon = '/adminUi/merchant.svg';
export const BulkPayIcon = '/adminUi/bulkPaymentIcon.svg';
export const SendIcon = '/adminUi/send.svg';
export const ReceiveIcon = '/adminUi/receive.svg';
export const TickerUpIcon = '/adminUi/tickerArrowUp.svg';
export const TickerDownIcon = '/adminUi/tickerArrowDown.svg';
